import moment from 'moment';
import React from 'react';
import { createLeftButton, createRightButton } from './helperCreateElement';
import { IHeader } from './types';

const Header = ({ currentMoment, selectedMoment = moment(), leftIconId, rightIconId, minDate, maxDate }: IHeader) => {
  if (currentMoment.get('month') === 0) {
    return (
      <>
        <strong style={{ textTransform: 'capitalize' }}>{currentMoment.format('MMMM')}</strong>
        <span style={{ fontWeight: 400 }}>{` ${currentMoment.format('YYYY')}`}</span>
      </>
    );
  }

  if (
    selectedMoment.get('month') === moment().subtract(minDate, 'months').startOf('month').get('month') &&
    selectedMoment.get('year') === moment().subtract(minDate, 'months').startOf('month').get('year')
  ) {
    createLeftButton(leftIconId);
  }

  if (
    selectedMoment.get('month') ===
      moment()
        .add(maxDate ? maxDate - 1 : maxDate, 'months')
        .endOf('month')
        .get('month') &&
    selectedMoment.get('year') ===
      moment()
        .add(maxDate ? maxDate - 1 : maxDate, 'months')
        .endOf('month')
        .get('year')
  ) {
    createRightButton(rightIconId);
  }

  return (
    <strong style={{ textTransform: 'capitalize' }} data-testid="header-month">
      {currentMoment.format('MMMM')}
    </strong>
  );
};

export default Header;
